var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4304_3364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 47.25H40.5C42.3675 47.25 43.965 46.125 44.64 44.505L51.435 28.6425C51.6375 28.125 51.75 27.585 51.75 27V22.5C51.75 20.025 49.725 18 47.25 18H33.0525L35.19 7.7175L35.2575 6.9975C35.2575 6.075 34.875 5.22 34.2675 4.6125L31.8825 2.25L17.055 17.0775C16.245 17.8875 15.75 19.0125 15.75 20.25V42.75C15.75 45.225 17.775 47.25 20.25 47.25ZM20.25 20.25L30.015 10.485L27 22.5H47.25V27L40.5 42.75H20.25V20.25ZM2.25 20.25H11.25V47.25H2.25V20.25Z",
    fill: "#A6ABB9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4304_3364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector2.3a4013bc5430953c4cdaac4a7b3b4bb5.svg";
export { ForwardRef as ReactComponent };